import { Helpers } from '../../helpers';
import { IScenarioBuildStatusType } from '../../interfaces/iscenario-build-status-type';
import { ScenarioBuildStatus } from '../scenario-build-status';

export class ScenarioBuildStatusTypeBase {
  ScenarioBuildStatusTypeId: number;
  Name: string;
  Value: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioBuildStatuses_ScenarioBuildStatusType?: Array<ScenarioBuildStatus> | null;

  constructor(item?: IScenarioBuildStatusType) {
    if (item) {

      this.ScenarioBuildStatusTypeId = item.ScenarioBuildStatusTypeId;
      this.Name = item.Name;
      this.Value = item.Value;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioBuildStatuses_ScenarioBuildStatusType = Helpers.createClassArray(ScenarioBuildStatus, item.ScenarioBuildStatuses_ScenarioBuildStatusType);
    }
  }
}